/**
 * POS-9667: the seller fee the seat-saver price preview converts proceeds with.
 *
 * The server resolves it for the event — office, then country override, then account, with the
 * seat-saver fee winning over the seller fee — so the preview uses the same fee the created listing
 * is priced with. It is null when the fee-by-country feature is off, and the account-level fee applies
 * as it did before.
 */
export const getSeatSaverSellerFee = (
  serverSellerFee: number | null | undefined,
  accountSellerFee: number | null | undefined
): number | null => serverSellerFee ?? accountSellerFee ?? null;
